import React from "react";
import ReactModal from 'react-modal';
import { MdClose } from "react-icons/md";
import ReactMarkdown from "react-markdown";

const customStyles = {
  overlay : {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000
  },

  content: {
    
    background: '#fff',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    position: "absolute",
    inset: "50% auto auto 50%",
    border: "none",
    
    overflow: "hidden",
    borderRadius: "4px",
    outline: "none",
    padding: "15px",
    boxShadow:"rgba(0, 0, 0, 0.1) 0px 4px 10px",
    
    maxWidth:"50%",
  },
};

export default function LeavePopup({ isOpen, closeModal, onYes, onNo ,aggencyName ,resforPopUp}) {

  
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Modal"
      style={customStyles}
      className={"ReactModal__Content"}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header mb-4 d-flex justify-content-end align-items-center">
            <MdClose size={25} onClick={closeModal} style={{cursor:'pointer'}}/>
          </div>

          <div className="modal-body">
            <div className="form-group text-center">
              <ReactMarkdown components={{ p: React.Fragment }}>
                                        {aggencyName}
                                      </ReactMarkdown>
              <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginTop: "12px" }}>
                { resforPopUp?.buttonYes && resforPopUp?.buttonNo && (
                  <>
                    <button className="faq-button" onClick={onYes} > {resforPopUp?.buttonYes}</button>
                    <button className="faq-button" onClick={onNo} >{resforPopUp?.buttonNo}</button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
}
